import { Box } from "@mui/material";
import PieChart from "../../../../components/PieChart";
import DashboardLayout from "../../../../components/global/DashboardLayout";
import DashboardHeader from "../../../../components/global/DashboardHeader";

const Pie = () => {
  return (
    <DashboardLayout>
      <Box m="20px">
        <DashboardHeader title="Pie Chart" subtitle="Simple Pie Chart" />
        <Box height="70vh">
          <PieChart />
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default Pie;
